<template>
    <div>
        <v-btn
            :background-color="$store.getters.getColorPalette().background1ColorCode"
            :color="$store.getters.getColorPalette().accent"
            small 
            text
            :dark="$store.getters.getColorPalette().isDark"
            outlined
            @click="dialog = !dialog"
        >
            {{ $store.getters.getTextMap().create_department }} <v-icon right :dark="$store.getters.getColorPalette().isDark" :color="$store.getters.getColorPalette().btnborderColorCode">mdi-alpha-d-box</v-icon>
        </v-btn>
        <v-dialog v-model="dialog" max-width="290">  
            <CreateDepartment v-on:close="onClose" />
        </v-dialog>
    </div>
</template> 
<script>
import CreateDepartment from '@/components/crud_components/CreateDepartment';
export default {
    name:'CreateDepartmentModal',
    components:{
        CreateDepartment
    },
    data () {
    return {
        dialog: false,
        valid:false,
    }
    },
    methods:{
        onClose(){
            this.dialog=false
            this.$emit('close')
        }
    }
}
</script>
<style scoped>
.emailgrp{
    border:3px solid;
    border-radius:20px;
}
.theme--light.v-card{
    background-color: #263238
}
</style>